import { z } from "zod";

export const AssetValue = z.object({});
